import React from 'react'
import Rheostat from 'rheostat';
import qs from 'qs';

class RangeSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 'active',
      collapse: 'in'
    }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const classList = event.target.className;
    if (classList.indexOf("active") >= 0) {
      this.setState({
        active: '',
        collapse: '',
      });
    } else {
      this.setState({
        active: 'active',
        collapse: 'in',
      });
    }
  }

  render() {
    const { name, min, max, leftHandleValue, rightHandleValue, onSliderDragEnd, onValuesUpdated } = this.props
    if (min !== max) {
      return (
        <div>
          <h5 className={`cars-search-option year-option ${this.state.active}`} data-toggle="collapse" data-target={`.${name}`} onClick={this.handleClick}>{name}</h5>
          <div className={`cars-collapse ${name} collapse ${this.state.collapse}`}>
            <div className="slidebar-container">
              <Rheostat min={parseInt(min)} max={parseInt(max)} values={[parseInt(leftHandleValue), parseInt(rightHandleValue)]} onSliderDragEnd={onSliderDragEnd} onValuesUpdated={onValuesUpdated} orientation={"horizontal"} />
            </div>
            {this.props.children}
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default RangeSlider
